module.exports = __webpack_public_path__ + "static/media/4.5cc95349.png";